import { ReviewsResponse } from '../../types/Contentful/ContentfulTypes'
import { ProductTileV2 } from './productTileCollection'
import { ProductVariantHandler } from './ProductVariantHandler'

/**
 * Extracts common tile fields from ProductTileV2 template data
 */
export class ProductTileV2DataExtractor {
  static extractCommonFields(
    tileData: ProductTileV2,
    contentfulId: string | undefined,
    enableCampaignCallouts: boolean | undefined,
    reviewsData: ReviewsResponse | undefined,
    mpvId: string | undefined
  ): any {
    const variants = tileData.productsList?.selectedProductVariants
    const quantity = ProductVariantHandler.getQuantity(variants)

    return {
      contentful_id: contentfulId,
      ...(tileData.tileDetails?.header?.value && {
        name: tileData.tileDetails.header.value
      }),
      ...(tileData.tileDetails?.description?.value && {
        description: tileData.tileDetails.description.value
      }),
      ...(tileData.tileDetails?.formattedDescription?.value && {
        formattedDescription: tileData.tileDetails.formattedDescription.value
      }),
      ...(tileData.tileDetails?.image?.cloudinaryImage?.[0] && {
        image: tileData.tileDetails.image.cloudinaryImage[0]
      }),
      ...(tileData.tileDetails?.link?.href && {
        linkUrl: tileData.tileDetails.link.href
      }),
      ...(tileData.calloutDetails && {
        callout: tileData.calloutDetails
      }),
      ...(tileData.allAvailableTags && {
        allAvailableTags: tileData.allAvailableTags
      }),
      enableCampaignCallouts: enableCampaignCallouts ?? false,
      selectedProductVariants: ProductVariantHandler.getSelections(variants),
      ...(quantity && { quantity }),
      ...(mpvId && reviewsData?.[mpvId] && { review: reviewsData[mpvId] })
    }
  }

  static hasExplicitLink(tileData: ProductTileV2): boolean {
    return !!tileData.tileDetails?.link?.linkType
  }
}
